module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-kansai-2-16bdb42596a1ef460a16304541bd5a37.png";